import React from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { Button } from '../design-system';

interface CloseButtonProps {
  onClick?: () => void;
  fontSize?: number;
  [key: string]: any;
}

const CloseButton = ({ onClick, fontSize, ...props }: CloseButtonProps) => (
  <Button
    title="Close"
    aria-label="Close"
    variant="primaryText"
    onClick={onClick}
    {...props}
  >
    <AiOutlineCloseCircle fontSize={fontSize || 22} />
  </Button>
);

export default CloseButton;
